export const D2NA_SHORT_NAME = 'D2NA';
export const D2NA_FULL_NAME = 'D2 Network Associates';
